(function () {
  class MusicManager extends PIXI.Container {
    constructor() {
      super();

      this._baseID = [];
      this._baseMusic = [
        {
          sound: "baseThemeLevel0",
          volume: 1,
        },
        {
          sound: "baseThemeLevel1",
          volume: 1,
        },
        {
          sound: "baseThemeLevel2",
          volume: 1,
        },
        {
          sound: "baseThemeLevel3",
          volume: 1,
        },
      ];

      this._freeSpinsID = [];
      this._freeSpinsMusic = [
        {
          sound: "freeSpinsThemeLevel1",
          volume: 0.6,
        },
        {
          sound: "freeSpinsThemeLevel2",
          volume: 0.6,
        },
        {
          sound: "freeSpinsThemeLevel3",
          volume: 0.6,
        },
      ];

      this._cashLinkID = [];
      this._cashLinkMusic = [
        {
          sound: "cashLinkThemeLevel1",
          volume: 0.6,
        },
        {
          sound: "cashLinkThemeLevel2",
          volume: 0.6,
        },
        {
          sound: "cashLinkThemeLevel3",
          volume: 0.6,
        },
      ];

      this._fadeBaseTimeIn = 2;
      this._fadeBaseTimeOut = 3;

      this._lowerVolume = 0.3;

      this._currentLevel = 0;
      this._currentBaseLevel = 0;
      messageBus.subscribe(
        "sounds:restorePreviouslyPlayingAudio",
        this.onRestorePreviouslyPlayingAudio.bind(this)
      );
    }

    onRestorePreviouslyPlayingAudio(data) {
      if (data.reason === "back from replay" && !Reflex.replayGame) {
        this._baseID = [];
        this._freeSpinsID = [];
        this._cashLinkID = [];
        this.setUpSounds();
      }
    }

    setUpSounds() {
      for (var i = 0; i < this._baseMusic.length; i++) {
        this._baseID.push(soundManager.play(this._baseMusic[i].sound));
        soundManager.setVolume(0, this._baseID[i]);
      }

      for (var j = 0; j < this._freeSpinsMusic.length; j++) {
        this._freeSpinsID.push(
          soundManager.play(this._freeSpinsMusic[j].sound)
        );
        soundManager.setVolume(0, this._freeSpinsID[j]);
      }

      for (var k = 0; k < this._cashLinkMusic.length; k++) {
        this._cashLinkID.push(soundManager.play(this._cashLinkMusic[k].sound));
        soundManager.setVolume(0, this._cashLinkID[k]);
      }

      this.fadeLevels(0, "base");
    }

    getMaxVolume(index, listType) {
      let list;

      switch (listType) {
        case "base":
          list = this._baseMusic;
          break;
        case "freeSpins":
          list = this._freeSpinsMusic;
          break;
        case "cashLink":
          list = this._cashLinkMusic;
          break;
      }

      return list[index].volume;
    }

    fadeLevels(
      level,
      listType,
      fadeInTime = this._fadeBaseTimeIn,
      fadeOutTime = this._fadeBaseTimeOut,
      onComplete = undefined,
      delay = 0
    ) {
      let list;

      switch (listType) {
        case "base":
          list = this._baseID;
          break;
        case "freeSpins":
          list = this._freeSpinsID;
          break;
        case "cashLink":
          list = this._cashLinkID;
          break;
      }

      let soundsToFadeOut = [];
      let soundToFadeIn = list[level];

      for (var i = 0; i < list.length; i++) {
        if (i === level) {
          continue;
        }

        soundsToFadeOut.push(list[i]);
      }

      const volume = this.getMaxVolume(level, listType);
      soundManager.fade(volume, fadeInTime, soundToFadeIn, onComplete, delay);

      for (var i = 0; i < soundsToFadeOut.length; i++) {
        soundManager.fade(
          0,
          fadeOutTime,
          soundsToFadeOut[i],
          onComplete,
          delay
        );
      }

      this._currentLevel = level;
    }

    getMusicLevel() {
      return this._currentLevel;
    }

    increaseLevel(listType) {
      let limit;

      switch (listType) {
        case "freeSpins":
          limit = this._freeSpinsMusic.length - 1;
          break;
        case "cashLink":
          limit = this._cashLinkMusic.length - 1;
          break;
      }

      const newLevel = Math.min(this._currentLevel + 1, limit);

      if (this._currentLevel !== newLevel) {
        this._currentLevel = newLevel;
        this.fadeLevels(this._currentLevel, listType);
      }
    }

    increaseBaseLevel(win, stake) {
      let newLevel = 1;
      if (win != null && stake !== null) {
        if (this._currentBaseLevel === 2 && win >= 5 * stake) {
          newLevel = 3;
        } else if (this._currentBaseLevel === 1 && win > stake) {
          newLevel = 2;
        }
      }

      if (newLevel > this._currentBaseLevel) {
        this._currentBaseLevel = newLevel;
        this.fadeLevels(this._currentBaseLevel, "base");
      }
    }

    decreaseBaseLevel() {
      let newLevel = this._currentBaseLevel - 1;
      if (newLevel >= 0 && this._currentBaseLevel !== newLevel) {
        this._currentBaseLevel = newLevel;
        this.fadeLevels(this._currentBaseLevel, "base");
      }
    }

    fadeBaseMusicOff(time = this._fadeBaseTimeOut) {
      for (let i = 0; i < this._baseID.length; i++) {
        soundManager.fade(0, time, this._baseID[i]);
      }
    }

    fadeFreeSpinsMusicOff(
      time = this._fadeBaseTimeOut,
      exitingFeature = false
    ) {
      for (let i = 0; i < this._freeSpinsID.length; i++) {
        soundManager.fade(0, time, this._freeSpinsID[i]);
      }
      if (exitingFeature) {
        timerManager.addTimeout(time, function () {
          soundManager.play("freeSpinsEnd");
        });
      }
    }

    fadeCashLinkMusicOff(time = this._fadeBaseTimeOut, exitingFeature = false) {
      for (let i = 0; i < this._cashLinkID.length; i++) {
        soundManager.fade(0, time, this._cashLinkID[i]);
      }
      if (exitingFeature) {
        timerManager.addTimeout(time, function () {
          soundManager.play("cashLinkEnd");
        });
      }
    }

    onFreeSpinsIntro() {
      this.fadeBaseMusicOff(0.3);
      this.fadeCashLinkMusicOff(0.3);
      soundManager.play("freeSpinsIntro");
      this.fadeLevels(0, "freeSpins", 0.3, 0.3, undefined, 3);
    }

    onCashLinkIntro() {
      this.fadeBaseMusicOff(0.3);
      this.fadeFreeSpinsMusicOff(0.3);
      soundManager.play("cashLinkIntro");
      this.fadeLevels(0, "cashLink", 0.3, 0.3, undefined, 3);
    }

    onFreeSpinsOutro() {
      this.fadeFreeSpinsMusicOff(0.3, true);
      this.fadeLevels(0, "base", 0.3, 0.3, undefined, 1.5);
    }

    onCashLinkOutro() {
      this.fadeCashLinkMusicOff(0.3, true);
      const returnMusic = gameController.inFreeSpins ? "freeSpins" : "base";
      this.fadeLevels(0, returnMusic, 0.3, 0.3, undefined, 1.5);
    }

    setIdleMusic(exitingFeature = false, continueBase = false) {
      const fadeTime = exitingFeature ? 0.3 : 0;
      this._currentLevel = 0;
      this._currentBaseLevel = continueBase ? this._currentBaseLevel : 0;
      this.fadeLevels(this._currentBaseLevel, "base", fadeTime, fadeTime);

      this.fadeFreeSpinsMusicOff(fadeTime);
      this.fadeCashLinkMusicOff(fadeTime);
    }

    isFreeSpinsPlaying() {
      return (
        soundManager.getSound(this._freeSpinsID[0]).volume > 0 ||
        soundManager.getSound(this._freeSpinsID[1]).volume > 0 ||
        soundManager.getSound(this._freeSpinsID[2]).volume > 0
      );
    }

    isCashLinkPlaying() {
      return (
        soundManager.getSound(this._cashLinkID[0]).volume > 0 ||
        soundManager.getSound(this._cashLinkID[1]).volume > 0
      );
    }

    fadeOutAllMusic(time = this._fadeBaseTimeOut) {
      this.fadeBaseMusicOff(time);
      this.fadeFreeSpinsMusicOff(time);
      this.fadeCashLinkMusicOff(time);
    }

    startCountUp() {
      soundManager.play("countUpLoop");
    }

    endCountUp() {
      soundManager.stop("countUpLoop");
      soundManager.play("countUpLoopEnd");
    }

    startBigWin() {
      soundManager.play("bigWinLoop");
    }

    endBigWin() {
      soundManager.stop("bigWinLoop");
      soundManager.play("bigWinLoopEnd");
    }
  }

  let musicManagerCreator = function (json) {
    return new MusicManager();
  };

  let musicManagerInitialiser = function (json, obj) {};

  let musicManagerFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "MusicManager",
    musicManagerCreator,
    musicManagerInitialiser,
    musicManagerFilesRequired
  );
})();
